<template>
	<div id="app">  
    <router-view></router-view>
	</div>
</template>

<script>
import Disclaimer from './components/Disclaimer'
import FontAwesome from '@/assets/font/fa.js'

export default {
	name: 'app',

	components: {
		Disclaimer
	},

  data () {
    return {
      currentView: 'dashboard'
    }
  }
}
</script>

<style>
.main-container {
  padding-top: 3em;
}

</style>



// WEBPACK FOOTER //
// src/App.vue